import { EventEmitter, Output, Input, Component } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { Observable } from 'rxjs/Observable';
import { CartService } from '../Services/cart';
import { ProductService } from '../Services/product';
import { AlertService } from '../Services/alert';
import { AuthService } from '../Services/auth';
import { ImageUtils } from '../Services/imageutils';
import { Config } from '../Services/config';
import { Cart } from '../Models/cart';
import { User } from '../Models/user';


@Component({
    selector: 'cart-detail',
    templateUrl: '../Templates/cart.detail.html',
})


export class CartDetailComponent {

  @Input() showCheckoutButton = true;
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(private cartService: CartService,
              private router: Router,
              private config: Config,
              private productService: ProductService,
              private alert: AlertService,
              private auth: AuthService,
              private imageUtils: ImageUtils
             ) {
  }

  cart: Cart;
  user: User;
  ttl: number;
  interval;

  private cart_ttl: Observable<number>;

  /**
   * Handle updated cart. Set ttl, and restart interval. A ttl of -1
   * is considered to be eternal life...
   */
  private cartUpdated(cart): void {

    if (!cart) {
      return;
    }

    this.cart = cart;
    this.ttl = cart.ttl;

    if (this.interval) {
      this.interval.unsubscribe();
    }

    if (this.ttl > 0) {
      this.cart_ttl = IntervalObservable.create(30 * 1000);

      this.interval = this.cart_ttl.subscribe(
        data => {
          this.ttl = Math.max(0, (this.ttl - 60));

          if (this.ttl == 0) {
            this.alert.error("Your shopping cart has expired!", true);
            this.cartService.create().subscribe(
              cart => this.cartUpdated(cart)
            );
          } else if (this.ttl < 300 && this.ttl > 0) {
            this.alert.warn("Your shopping cart has almost expired!", true);
          }
        }
      );
    }
  }

  closeCart(): void {
    // signal to outside world that we close the dropdown
    this.close.emit(null);
  }

  rmFromCart(product): void {

    this.cartService.rmProduct(product).subscribe(
      cart => this.cartUpdated(cart),
      err => {
        this.alert.error("Couldn't remove item");
      }
    );
  }

  subtotal(): number {
    return this.cartService.subtotal();
  }

  /**
   * Start payment procedure.
   */
  pay(cart: Cart): void {
    if (!this.user) {
      this.alert.error("Couldn't start payment: no user");
    } else {
      this.router.navigate(['/checkout']);
    }
  }

  ngOnInit() {

    this.cartService.getCart().subscribe(
      cart => this.cartUpdated(cart)
    );
    this.auth.getUser().subscribe(user => this.user = user);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/cart.detail.ts